import { render } from "./Trace.vue?vue&type=template&id=0556ee6a&scoped=true"
import script from "./Trace.vue?vue&type=script&lang=ts"
export * from "./Trace.vue?vue&type=script&lang=ts"

import "./Trace.vue?vue&type=style&index=0&id=0556ee6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0556ee6a"

export default script